const PREFIX = 'MEMBER_PROFILE_GENERAL_INFO_';

export const SET_LOADING = `${PREFIX}SET_LOADING`;
export const UNSET_LOADING = `${PREFIX}UNSET_LOADING`;
export const SET_FIELDS = `${PREFIX}SET_FIELDS`;